export const environment = {
  production: false,
  keycloakTokenUrl: 'https://auth.internal.vayana.com/realms/devtools/protocol/openid-connect/token',
  LogoutUrl: "https://auth.internal.vayana.com/realms/devtools/protocol/openid-connect/logout",
  clientId: 'marvelgate',
  clientSecret: '7xtNqxdqpx8pLIJg23cqZZpyecQSt986',
  API_END_POINT: "https://s.api.one.vayana.com",
};
